module.exports = __webpack_public_path__ + "static/media/BodyScan5.5b23e933.m4a";